"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionsService = void 0;
class ActionsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Send a slack message
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    sendSlackMessage(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/actions/slack',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Send a notification regarding a deployment
     * @param requestBody
     * @returns DeploymentNotificationResponse
     * @throws ApiError
     */
    sendDeploymentNotification(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/actions/notification',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Test workflow automation for outreach in scale
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    testOutreachUsingWorkflow(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/actions/test',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.ActionsService = ActionsService;
